import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import actorReducer from './actor-reducer';
import audienceSegmentReducer from './audience-segment-reducer';
import authReducer from './auth-reducer';
import embedReducer from './embed-reducer';
import errorReducer from './error-reducer';
import downtimeReducer from './downtime-reducer';
import filtersReducer from './filters-reducer';
import movieReducer from './movie-reducer';
import networkReducer from './network-reducer';
import queryReducer from './query-reducer';
import showReducer from './show-reducer';
import userReducer from './user-reducer';
import reportBuilderReducer from './report-builder-reducer';

const rootReducer = combineReducers({
  actors: actorReducer,
  auth: authReducer,
  audienceSegment: audienceSegmentReducer,
  embeds: embedReducer,
  errorMessage: errorReducer,
  downtime: downtimeReducer,
  filters: filtersReducer,
  movies: movieReducer,
  networks: networkReducer,
  queries: queryReducer,
  shows: showReducer,
  user: userReducer,
  router: routerReducer,
  reportBuilder: reportBuilderReducer
});

export default rootReducer;
